import { ISignatureProviderProfile } from "./ISignatureProvider";

export interface ISignatureData {
    /**
     * Skutečný detached podpis v textové podobě
     */
    signature: string;

    /**
     * Profil, pomocí kterého byl podpis vytvořen
     */
    profile: ISignatureProviderProfile;
}
